import { useMemo } from 'react';
import type { WithReferralAddressInput } from '@soundxyz/utils/constants/embeds';
import { WithReferralAddress } from '@soundxyz/utils/constants/embeds';
import { useAuth } from '@context/auth/base';
import { KeepCurrentBrowserHost } from '@utils/url';
import { useCopy } from './useCopy';

export function useUrlWithAuthReferral({
  url,
  source,
  isReferrable,
}: { url: string; isReferrable: boolean } & Pick<WithReferralAddressInput, 'source'>) {
  const { authUserAddress: referralAddress = null } = useAuth();

  const urlWithReferral = useMemo(() => {
    return KeepCurrentBrowserHost(
      WithReferralAddress(url, {
        referralAddress: isReferrable ? referralAddress : null,
        source,
      }),
    ).href;
  }, [url, isReferrable, referralAddress, source]);

  const { copy: copyUrlWithReferral, isCopied } = useCopy({
    text: urlWithReferral,
    successMessage: 'Link copied to clipboard',
  });

  return {
    isCopied,
    copyUrlWithReferral,
    urlWithReferral,
    referralAddress: isReferrable ? referralAddress : null,
  };
}
